module.exports = __webpack_public_path__ + "img/HeroTwo.0b20a87a.jpg";